import styled from 'styled-components';
import { Typography } from '@web-chat-core/ui-kit';

export const StyledSvg = styled.svg`
    transform: rotate(-90deg); /* Разворачиваем, чтобы прогресс шел сверху */
`;

export const CircleBackground = styled.circle<{ $progressBarWidth: number }>`
    stroke: ${(props) => props.theme.root.colors.primary['20%']};
    fill: ${(props) => props.theme.root.colors.primary['20%']};
`;

export const CircleProgress = styled.circle<{ $progressBarWidth: number }>`
    stroke: ${(props) => props.theme.root.colors.primary.default};
    fill: none;
    stroke-width: ${(props) => props.$progressBarWidth};
    stroke-linecap: round;
    transition: stroke-dasharray 1s linear;
`;

export const Container = styled.div<{ $size: number }>`
    position: relative;
    width: ${(props) => props.$size}px;
    height: ${(props) => props.$size}px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Content = styled.div`
    position: absolute;
`;

export const Time = styled(Typography)`
    font-weight: bold;
`;
